import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { PurchaseFlowComponent } from 'src/app/shared/cinejoy/common/purchase-flow/purchase-flow.component';
import * as moment from 'moment-timezone';
import { MatDialog } from '@angular/material/dialog';
import { CreateGroupPopupComponent } from 'src/app/features/group-sharing/create-group-popup/create-group-popup.component';
import { MyTicketCinejoy } from 'src/app/shared/cinejoy/spotlight/models/my-ticket-cinejoy/my-ticket-cinejoy.model';
import { MyTicketScreeningParties } from 'src/app/shared/cinejoy/spotlight/models/my-ticket-screening-parties/my-ticket-screening-parties.model';
import { AgileIntegrationService } from 'src/app/core/services/agile/agile-integration.service';
import { AuthenticationService } from 'src/app/core/services/Authentication/authentication.service';
import {GroupSharingService, WatchPartyType} from 'src/app/features/group-sharing/group-sharing.service.component';
import {UserInvitationService} from "../../../../core/services/user.invitation.service";
import {EditGroupPopupComponent} from "../../../group-sharing/edit-group-popup/edit-group-popup.component";
import {InvitationSource, WatchPartyRequestFlow} from "../../../../core/models/common.models";

@Component({
  selector: 'app-premiere-card-mobile-view',
  templateUrl: './premiere-card-mobile-view.component.html',
  styleUrls: ['./premiere-card-mobile-view.component.css'],
})
export class PremiereCardMobileViewComponent implements OnInit {
  @Input() premiere: any;

  premierelist: any;
  cinejoySchedule: any;
  datePipeString: string;
  joinButtonDisabled = false;
  currentTimeText: any;
  timeDifferance: any;
  spotlight: any = [];
  schedule: any = [];
  premierename: string;
  timezone: any;
  exsistingGroup:boolean = false;
  spotlightsTickets: any = new Array();
  showcaseTickets: MyTicketCinejoy[] = new Array();
  screeningPartiesTickets: MyTicketScreeningParties[] = new Array();
  isBuyButtonActive: boolean = false;
  eventDetails:any;
  archive = false
  constructor(private router: Router,
    private authService: AuthenticationService,
    private modalService: NgbModal,
    public dialog: MatDialog,
    private agileIntegration: AgileIntegrationService,
    private groupsharingService: GroupSharingService,
    private readonly userInvitationService: UserInvitationService) { }

  ngOnInit(): void {


    if (this.router.url.includes('archive')) {
      this.archive = true
    }
    else{
      this.archive = false
    }

    this.premierename = this.premiere.name.replace(/ /g, '-');
    var zone = moment.tz.guess();
    this.timezone = moment(this.premiere.cinejoySpotlightsSchedule[0].scheduleTimeText).tz(zone).zoneName();
    this.joinButtonEnable();
    if(!this.archive){
      this.authService.checkUserAuthenticated().subscribe((res)=>{
        if(res.userId > 0){
          this.fetchTickets()
        }
      }, err=>{

      })
    }
    this.getActiveParties();
  }

  open(eventId: number, premiere: any, purchaseStage: string): void {
    const modalRef = this.modalService.open(PurchaseFlowComponent, {
      size: 'lg',
      backdrop: 'static',
    });
    modalRef.componentInstance.eventId = eventId;
    modalRef.componentInstance.premiere = premiere;
    modalRef.componentInstance.purchaseStage = purchaseStage;
    modalRef.result.then(
      (result) => {

        this.fetchTickets()
      },
      (reason) => {

      },
    );
  }

  joinButtonEnable(): void {
    let currentTimeText = Date.now();
    this.premiere.cinejoySpotlightsSchedule =
      this.premiere.cinejoySpotlightsSchedule.sort(
        (x: any, y: any) =>
          +new Date(x.scheduleTimeText) - +new Date(y.scheduleTimeText)
      );
    const endOfFestivitiesAdd10 =
      this.premiere.cinejoySpotlightsSchedule[
        this.premiere.cinejoySpotlightsSchedule.length - 1
      ].scheduleTimeText +
      10 * 60 * 60 * 1000;
    setInterval(() => {
      currentTimeText = Date.now();
      if (
        this.premiere.cinejoySpotlightsSchedule[0].scheduleTimeText <=
        currentTimeText &&
        endOfFestivitiesAdd10 >= currentTimeText
      ) {
        this.joinButtonDisabled = false;
      } else if (
        this.premiere.cinejoySpotlightsSchedule[0].scheduleTimeText >
        currentTimeText
      ) {
        this.joinButtonDisabled = true;
      } else {
        this.joinButtonDisabled = true;
      }
    }, 1000);
  }

  redirect(): void {

    let userAgent = navigator.userAgent;
    let browserName;
    if (userAgent.match(/firefox|fxios/i)) {
      browserName = "Firefox";
      alert("Hi,\nFor a better experience please use Google Chrome, Safari or Microsoft Edge.\n\nThank you!")
    }

    const currentTimeText = Date.now();

    const groupSharingSchedule = this.premiere.cinejoySpotlightsSchedule.find((x: any) => x.scheduleMainText === 'GS1')
    const redCarpetSchedule = this.premiere.cinejoySpotlightsSchedule.filter((x: any) => x.scheduleMainText === 'Red Carpet');
    const groupSharingScheduleQA = this.premiere.cinejoySpotlightsSchedule.filter((x: any) => x.scheduleMainText === 'GS2');
    const openingRemarks = this.premiere.cinejoySpotlightsSchedule.filter((x: any) => x.scheduleMainText === 'Opening Remarks');
    const theaterURL = 'cinejoy/premiere/theater/' + this.premiere.eventId; // + '/' + this.premiere.name.replaceAll(' ', '-');
    const redCarpetURL = 'cinejoy/premiere/redcarpet/' + this.premiere.eventId + '/' + this.premiere.name.replaceAll(' ', '-');
    if (redCarpetSchedule === undefined || redCarpetSchedule === null) {
      this.router.navigate([theaterURL]);
    } else {
      if ((groupSharingSchedule.scheduleTimeText <= currentTimeText) && (currentTimeText <= redCarpetSchedule[0].scheduleTimeText)) {
        this.router.navigate(['cinejoy/spotlight-root/' + this.premiere.eventId + '/' + this.premiere.name.replaceAll(' ', '-')])
      } else if ((redCarpetSchedule[0].scheduleTimeText <= currentTimeText) && (this.premiere.cinejoySpotlightsSchedule[this.getRedCarpetIndex() + 1].scheduleTimeText >= currentTimeText)) {
        this.router.navigate(['cinejoy/spotlight-root/' + this.premiere.eventId + '/' + this.premiere.name.replaceAll(' ', '-')])
      } else if (groupSharingScheduleQA[0].scheduleTimeText <= currentTimeText) {
        this.router.navigate(['cinejoy/spotlight-root/' + this.premiere.eventId + '/' + this.premiere.name.replaceAll(' ', '-')])
      } else {
        this.router.navigate(['cinejoy/spotlight-root/' + this.premiere.eventId + '/' + this.premiere.name.replaceAll(' ', '-')])
      }
    }
  }

  getRedCarpetIndex(): number {
    let i = 0;
    for (const schedule of this.premiere.cinejoySpotlightsSchedule) {
      if (schedule.scheduleMainText === 'Red Carpet') {
        break;
      }
      i++;
    }
    return i;
  }

  gotoRedcarpet(eventId: any, name: any): void {
    this.router.navigate([`cinejoy/premiere/redcarpet/${eventId}/${name}`]);
  }

  gotoMoreInfo(eventId: any, name: any): void {
    this.router.navigate([`cinejoy/premiere/more-info/${eventId}/${name}`]);
  }

  openDialog(event) {
    if (this.exsistingGroup) {
      this.dialog.open(EditGroupPopupComponent, {
        panelClass: 'pre-schedule-modalbox',
        width: '600px',
        height: '70%',
        data: {
          eventId: event.eventId,
          isPreScheduleEvent: true,
          isEventStarted: this.joinButtonDisabled
        }
      }).afterClosed().subscribe((res) => {
        console.log('===== dialog closed with response: ', res);
        this.getActiveParties();
        if (res && res.invitedEmails) {
          this.inviteUser(res);
        }
      });
    } else {
      this.dialog.open(CreateGroupPopupComponent, {
        panelClass: 'pre-schedule-modalbox',
        width: '600px',
        height: '65%',
        data: {
          eventId: event.eventId,
          isPreScheduleEvent: true,
        },
      }).afterClosed().subscribe((res) => {

        if (res) {
          this.getActiveParties()
        }

      })
    }
  }

  fetchTickets(): void {
    //this.isLoading = true;
    this.agileIntegration.fetchTickets().subscribe(
      (response) => {
        // this.isLoading = false;
        const tickets = response.agiletixEvents ? response.agiletixEvents : [];

        this.spotlightsTickets = tickets.filter(
          (ticket) =>
            ticket.type !== undefined &&
            ticket.type !== null &&
            ticket.type.toLowerCase().includes('spotlight')
        );
        this.spotlightsTickets = this.spotlightsTickets.sort(
          (a, b) =>
            new Date(a.StartDateTime).getTime() -
            new Date(b.StartDateTime).getTime()
        );
        if (this.spotlightsTickets.find((v) => (v.AccessStatus === 'AccessValid' || v.AccessStatus === 'BeforeEvent') && v.ParentID == this.premiere.eventId)) {
          this.isBuyButtonActive = true;
        }


      },
      (error) => {
        //this.isLoading = false;

      }
    );
  }

  getActiveParties() {
    this.groupsharingService.getActiveWatchParty(this.premiere.eventId).subscribe((res) => {
      let item: any = '';
      if (localStorage.getItem('userData')) {
        item = JSON.parse(localStorage.getItem('userData'))
      }
      item['userId'] = item.userID ? item.userID : item.userId
      if (res.filter((v) => v.userId == item.userId).length > 0) {
        this.eventDetails = res.find((v) => v.userId == item.userId);
        this.exsistingGroup = true;
      } else {
        this.exsistingGroup = false;
      }
    }, err => {

    })
  }

  inviteUser(dialogResponse: any) {
    if (!dialogResponse.invitedEmails || !dialogResponse.invitedEmails.length) {
      return;
    }

    for (const email of dialogResponse.invitedEmails) {
      const invitationRequest = {
        emailAddress: email,
        invitedUserName: "Invited User",
        invitationSource: InvitationSource.WATCH_PARTY,
        invitationSourceMetadata: {
          watchPartyRequestFlow: WatchPartyRequestFlow.NEW_PARTICIPANT_ADDED,
          watchPartyParticipantRequest: {
            partyType: WatchPartyType.PRIVATE,
            customRoomId: dialogResponse.customRoomId,
            eventId: dialogResponse.eventId,
            userIds: []
          }
        }
      }

      this.userInvitationService.inviteNewUser(invitationRequest)
        .then(() => {
          console.log(`user: ${email} invited successfully`);
        });
    }
  }
}
